import { IUnitEventDetails, TUnitEventStatus } from './models';

interface IProps {
  details: IUnitEventDetails;
}

/**
 * Класс для хранения и передачи информации о статистике в объекте события
 */
export class UnitEvent {
  private details: IUnitEventDetails;

  /** Статус события */
  private status?: TUnitEventStatus;

  constructor({ details }: IProps) {
    this.details = details;
    this.status = 'processing';
  }

  /** Меняем статус для события как завершенное, т.е. следующие юниты его уже не будут обрабатывать */
  public done() {
    this.status = 'done';
  }

  /**
   * Проверка события.
   * Обычно нам необходимо проверить, что это то самое событие по нескольким параметрам:
   * - по имени
   * - по тому кто вызвал
   * - статус события. Важно, чтобы оно было не завершено
   */
  public isActiveEvent(): boolean {
    return this.status !== 'done';
  }

  public getData() {
    return {
      details: this.details,
    };
  }
}
